import Image from "next/image";
import type { ReactNode } from "react";

interface ImageTextProps {
  children?: ReactNode;
  imagePosition?: "left" | "right";
  imageSrc?: string;
  imageAlt?: string;
  imageSlot?: ReactNode;
  title?: string;
  text?: string;
}

export default function ImageText(props: ImageTextProps) {
  const imageElement =
    props.imageSlot ??
    (props.imageSrc && (
      <Image
        src={props.imageSrc}
        alt={props.imageAlt || "Image"}
        fill
        className="object-cover"
      />
    ));

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
      {props.imagePosition === "left" &&
        (props.imageSrc || props.imageSlot) && (
          <div className="relative w-full min-h-[300px] md:min-h-[450px]">
            {imageElement}
          </div>
        )}
      <div className="flex flex-col gap-4 justify-center py-10 px-8">
        {props.title && <h2 className="font text-4xl">{props.title}</h2>}
        {props.text}
        {props.children}
      </div>
      {props.imagePosition === "right" &&
        (props.imageSrc || props.imageSlot) && (
          <div className="relative w-full aspect-[4/3]">{imageElement}</div>
        )}
    </div>
  );
}
